import axios from '../../common/utils/interceptor';
import { apiUrls, routeMappings, SessionStore } from '../../constants';
import { History } from 'history';
import { getCookie } from '../../common/utils/cookies';
import i18n from '../../internationalization/internationalization';
import { eplResponse } from '../../constants/responseEnums';

export const initTCPlus = async (
  payload: {
    link: string;
    resetIndicator: boolean;
    assessmentCompletionURL?: string | null;
    assessmentNonCompletionURL?: string | null;
    testLinkURL?: string;
  },
  history: History<History.PoorMansUnknown>,
): Promise<void> => {
  try {
    const { data: responseData } = await axios.post(apiUrls.VALIDATE_TC_PLUS_LINK, payload);
    const locale = getCookie('locale_player') || 'EN_US';
    i18n.changeLanguage(locale.toLocaleLowerCase());
    if (responseData && responseData.experienceProps)
      sessionStorage.setItem(SessionStore.experienceProps, JSON.stringify(responseData.experienceProps));

    if (responseData && responseData.loginSuccess) {
      const tcPlusAuthStream = {
        apiSecret: responseData.apiSecret,
        apiToken: responseData.apiToken,
      };
      sessionStorage.setItem(SessionStore.tcPlusAuthStream, JSON.stringify(tcPlusAuthStream));
      if (responseData.companyLogoUrl) {
        sessionStorage.setItem(SessionStore.companyLogoUrl, responseData.companyLogoUrl);
      }

      if (responseData.productListing)
        sessionStorage.setItem(SessionStore.basicTaskList, JSON.stringify(responseData.productListing));

      if (responseData.projectSettings)
        sessionStorage.setItem(SessionStore.projectSettings, JSON.stringify(responseData.projectSettings));

      if (responseData.assessmentCompletionURL)
        sessionStorage.setItem(SessionStore.tpurlc, responseData.assessmentCompletionURL);
      if (responseData.assessmentNonCompletionURL)
        sessionStorage.setItem(SessionStore.tpurlnc, responseData.assessmentNonCompletionURL);
      if (responseData.companyBranding)
        sessionStorage.setItem(SessionStore.companyBranding, responseData.companyBranding);

      sessionStorage.setItem(SessionStore.basicTaskListHurdleIndicator, 'true');

      if (payload.resetIndicator) return;
      history.push({
        pathname: routeMappings['INIT_EXPERIENCE'],
        search: `?link=${payload.link}`,
      });
    } else if (responseData && !responseData.loginSuccess) {
      if (responseData.errorCode === eplResponse.DEADLINE_PASSED) {
        history.push(routeMappings['EXPIRED_LINK']);
      } else if (responseData.errorCode === eplResponse.LOCKDOWN_BROWSER) {
        sessionStorage.setItem(SessionStore.lockdownBrowserURL, responseData.lockdownBrowserURL);
        history.push(routeMappings['SECURE_BROWSER']);
      } else {
        history.push({ pathname: routeMappings['LINK_INVALID'], search: `?errorCode=${responseData.errorCode}` });
      }
    }
  } catch (error) {
    if (error && error.status === 400) {
      history.push(routeMappings['LINK_INVALID']);
    } else {
      history.push(routeMappings['NOT_FOUND']);
    }
  }
};
